import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"
import customParseFormat from "dayjs/plugin/customParseFormat"
import weekday from "dayjs/plugin/weekday"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)
dayjs.extend(weekday)
dayjs.tz.setDefault("Pacific/Honolulu")

function currencyFormat(amount = 0) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount)
}

function timeFormat(time) {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time,
  ]

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1) // Remove full string match value
    time[3] = +time[0] < 12 ? " AM" : " PM" // Set AM/PM
    time[0] = +time[0] % 12 || 12 // Adjust hours
  }
  return time.join("") // return adjusted time or original string
}

function getCheckoutNoteDisplayValue(checkoutNote) {
  if (!checkoutNote) return ""

  return checkoutNote
    .replace(
      /Delivery: (?:\d{4}-\d{2}-\d{2})(?: (?:\d{1,2}\:\d{2} (?:AM|PM)) - (?:\d{1,2}\:\d{2} (?:AM|PM)))?/g,
      "",
    )
    .trim()
}

function getCheckoutNoteValue(checkoutNote, deliverySchedule) {
  if (checkoutNote !== "") {
    if (checkoutNote.startsWith("Delivery:")) {
      checkoutNote = checkoutNote.replace(
        /Delivery: (?:\d{4}-\d{2}-\d{2})(?: (?:\d{1,2}\:\d{2} (?:AM|PM)) - (?:\d{1,2}\:\d{2} (?:AM|PM)))?/g,
        `Delivery: ${deliverySchedule}`,
      )
    } else {
      checkoutNote = `Delivery: ${deliverySchedule} ${checkoutNote}`
    }
  } else {
    checkoutNote = `Delivery: ${deliverySchedule}`
  }

  return checkoutNote
}

function getDeliveryScheduleFromCheckoutNote(checkoutNote) {
  const matches =
    /(Delivery: (?:\d{4}-\d{2}-\d{2})(?: (?:\d{1,2}\:\d{2} (?:AM|PM)) - (?:\d{1,2}\:\d{2} (?:AM|PM)))?)/g.exec(
      checkoutNote,
    )

  return matches[0] || null
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export {
  dayjs,
  currencyFormat,
  timeFormat,
  getCheckoutNoteDisplayValue,
  getCheckoutNoteValue,
  getDeliveryScheduleFromCheckoutNote,
  sleep,
}
